import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { ITEM_STATUS } from 'domains/customer-order/constants'
import StringUtil from 'utils/string-util'

const propTypes = {
  status: PropTypes.string
}

/**
 * @param {string} status
 */
const CustomerOrderItemStatusBadge = ({ status }) => {

  const colorMap = {
    [ITEM_STATUS.ORDERED]           : 'warning',
    [ITEM_STATUS.PAID]              : 'info',
    [ITEM_STATUS.CONFIRM_COD]       : 'info',
    [ITEM_STATUS.SHIPPED]           : 'primary',
    [ITEM_STATUS.DELIVERED]         : 'success',
    [ITEM_STATUS.SHIPMENT_FAILED]   : 'danger',
    [ITEM_STATUS.REFUND_PROCESSING] : 'primary',
    [ITEM_STATUS.COMPLETED]         : 'success',
    [ITEM_STATUS.REFUNDED]          : 'danger',
    [ITEM_STATUS.CANCELLED]         : 'danger'
  }

  const color = colorMap[status] || 'default'

  return <StatusBadge color={ color } label={ StringUtil.humanize(status) } />
}

CustomerOrderItemStatusBadge.propTypes = propTypes

export default CustomerOrderItemStatusBadge